import React from 'react'
import { DropzoneNarrative, DropzonePanel, IconHolder } from './dropzoneStyles'
import { csvFileIcon, uploadFileIcon } from './uploadIcons'
import { Locale, Translation } from 'locale'
import { TextButton, TextButtonType } from 'view/components/buttons'

type UploadDropzoneEmptyProps = {
  narrative: string
  handleDropFiles: (files: File[]) => void
  handlePaste?: (clipboard: string) => void
  dataTestId?: string
  buttonDataTestId?: string
  accept?: string
}

export const UploadDropzoneEmpty: React.FunctionComponent<UploadDropzoneEmptyProps> = props => {
  const { narrative, handleDropFiles, handlePaste, dataTestId, buttonDataTestId, accept } = props
  return (
    <DropzonePanel
      data-test-id={dataTestId}
      dataTestId={dataTestId}
      render={onClick => (
        <>
          <IconHolder isFull={false}>{uploadFileIcon}</IconHolder>
          <DropzoneNarrative isFull={false}>{narrative}</DropzoneNarrative>
          <TextButton dataTestId={buttonDataTestId} type={TextButtonType.Tertiary} onClick={onClick}>
            {Locale.translate(Translation.TC_BROWSE_FILE)}
          </TextButton>
        </>
      )}
      onDropFiles={handleDropFiles}
      onPaste={handlePaste}
      allowClick={true}
      accept={accept}
    />
  )
}

type UploadDropzoneFullProps = {
  uploadFile: File | undefined
  clipboard?: string | undefined
  handleDropFiles: (files: File[]) => void
  handlePaste?: (clipboard: string) => void
  accept?: string
  dataTestId?: string
}

export const UploadDropzoneFull: React.FunctionComponent<UploadDropzoneFullProps> = props => {
  const { uploadFile, clipboard, dataTestId, handleDropFiles, handlePaste, accept } = props

  if (!uploadFile && !clipboard) {
    return <>{'No file/clipboard has been selected'}</>
  }

  return (
    <DropzonePanel
      dataTestId={dataTestId}
      render={onClick => (
        <>
          <IconHolder isFull={true}>{uploadFile ? csvFileIcon : uploadFileIcon}</IconHolder>
          <DropzoneNarrative isFull={true}>{uploadFile?.name ?? Locale.translate(Translation.SC_CLIPBOARD)}</DropzoneNarrative>
          <TextButton type={TextButtonType.Tertiary} onClick={onClick}>
            {uploadFile ? Locale.translate(Translation.TC_CHANGE_FILE) : Locale.translate(Translation.TC_BROWSE_FILE)}
          </TextButton>
        </>
      )}
      onDropFiles={handleDropFiles}
      onPaste={handlePaste}
      allowClick={true}
      accept={accept}
    />
  )
}
